module.exports = __webpack_public_path__ + "img/koi.60c729d9.png";